<template>
  <section class="category" v-if="categories.length > 0">
    <HeadingLv3 :text="'カテゴリーから選ぶ'" />
    <div>
      <div v-for="category in categories" :key="category.id">
        <router-link :to="'/faq/list/' + category.slug">
          <img :src="category.acf.faq_cat_icon.url" alt="" />
          <p>{{ category.name }}</p>
        </router-link>
        <p>{{ category.description }}</p>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { ref } from 'vue'

import HeadingLv3 from '@/components/elements/HeadingLv3.vue'

import { axiosSetting } from '@/utils/axiosSetting'

export default {
  name: 'FaqCategories',
  components: {
    HeadingLv3
  },
  setup() {
    const categories = ref([])
    const ajax = axiosSetting('cms', 'block')

    const getCategories = () => {
      ajax
        .get(`${process.env.VUE_APP_WPAPI_URL}wp-json/wp/v2/faq_category`)
        .then((res) => {
          categories.value = res.data
        })
    }

    getCategories()

    return {
      categories
    }
  }
}
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.category {
  > div:last-of-type {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    column-gap: 18px;
    row-gap: 20px;
    margin-top: 20px;
    @include mixins.media() {
      grid-template-columns: repeat(6, minmax(0, 1fr));
      column-gap: 40px;
    }
  }
}
a {
  display: inline-flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: var.$color-main-text;
  line-height: 1.5;
  height: 120px;
  width: 100%;
  border: 1px solid var.$color-border-gray;
  margin-bottom: 13px;
  border-radius: 10px;
  box-shadow: rgba(0, 0, 0, 0.08) 0 3px 6px;
  @include mixins.media() {
    height: 110px;
  }
}
img {
  margin-bottom: 15px;
}
// .category div div:last-of-type {
//   a {
//     justify-content: start;
//     padding-top: 41px;
//   }
//   img {
//     // margin-bottom: 31px;
//     margin-bottom: 20px;
//   }
// }
a + p {
  line-height: 1.58;
  font-size: 1.2rem;
}
</style>
